import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

const BidButton = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};

  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClick = (type, e) => {
    e.stopPropagation();
    if (type === "material") {
      context.onClickshowbiddata(props);
    }
  };

  const isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(":") || !createDate)
      return true;

    const [hours, minutes] = biddingWindow.split(':').map(Number);
      const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30'); // IST
      const biddingEndTime = new Date(localCreateDate);
      biddingEndTime.setHours(biddingEndTime.getHours() + hours);
      biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

      const currentTime = new Date();
      const difference = biddingEndTime - currentTime;

      const h = String(Math.max(Math.floor(difference / (1000 * 60 * 60)), 0)).padStart(2, '0');
      const m = String(Math.max(Math.floor((difference / (1000 * 60)) % 60), 0)).padStart(2, '0');
      const s = String(Math.max(Math.floor((difference / 1000) % 60), 0)).padStart(2, '0');

      if (h === '00' && m === '00' && s == '00') return true;
  };

  const isEnabled =
    Array.isArray(indent.vendorquotes) &&
    indent.vendorquotes.length > 0 &&
    //  indent.validity_end !== 1 &&
    indent.vehicle_placement_expiried !== 1 &&
    isBiddingWindowExpired(indent.bidding_window, indent.create_date)||indent.indent_assigned==1

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY,
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
    <div style={{ display: "flex", gap: "5px", position: "relative" }}>
      {indent.is_draft === 1 ? null : (
        <>
          <button
            onClick={(e) => {
              if (isEnabled) {
                handleClick("material", e);
              }
            }}
            className="custom-btn label label-success"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
          >
            <img
              src={
                isEnabled
                  ? require("../../assets/images/bidenable.svg")
                  : require("../../assets/images/biddisable.svg")
              }
              style={{ position: "relative" }}
              alt="Bid Details"
            />
          </button>
          {showPopover && (
            <PopoverContent
              content="Bid Details"
              position={position}
              onClose={() => setShowPopover(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default BidButton;
